export const MANDATORY_SURVEY = "mandatory_survey";
export const OPTIONAL_SURVEY = "optional_survey";
export const LEGAL_NOTES = "legal_notes";
export const ADDITIONAL_CASES = "additional_cases";
